import {Injectable} from '@angular/core';
import {
  DialogWidth,
  PermissionsService,
  SessionService,
  REPORT_MODAL_TYPE,
  MapTypes,
  DiagramTypes as DiagramReportTypes
} from '@q9elements/ui-kit/common';
import {ReportModalComponent} from '@q9elements/ui-kit/components';
import {PopupManagerService} from '../../core/services/popup-manager.service';
import {ClientEnvService} from '../../core/services/client-env.service';

@Injectable()
export class CommonWrapperDialogService {
  constructor(
    private sessionService: SessionService,
    private permissionsService: PermissionsService,
    private popupSvc: PopupManagerService,
    private clientEnvSvc: ClientEnvService
  ) {}

  openReportsDialog(
    modalType: REPORT_MODAL_TYPE,
    teamId: string,
    state: string,
    diagramId: string,
    diagramType: MapTypes,
    enabledDiagramReportTypes?: DiagramReportTypes[]
  ) {
    const userInTeam = this.sessionService.user()!.userInTeam!;
    const currentTeam = {
      _id: teamId,
      name: userInTeam.team.name,
      planType: userInTeam.team.plan.type,
      teamIndex: this.sessionService.teamIndex(),
      trialExpired: !this.permissionsService.isProActive()
    };

    this.popupSvc.open(ReportModalComponent, {
      width: DialogWidth.LG_XL,
      panelClass: ['q9-dialog', 'report-dialog'],
      data: {
        currentTeam,
        modalType,
        generalReportType: 'diagram',
        anchorTarget: this.clientEnvSvc.anchorTarget,
        metadata: {
          state,
          diagramId,
          diagramType,
          enabledDiagramReportTypes
        }
      }
    });
  }
}
